import React from "react";
import { Shield, Clock, Users, Award, Truck, Target, Eye } from "lucide-react";

const About = () => {
  const stats = [
    {
      icon: <Shield className="h-6 w-6" />,
      value: "15+",
      label: "Years Experience",
    },
    {
      icon: <Users className="h-6 w-6" />,
      value: "1000+",
      label: "Happy Clients",
    },
    {
      icon: <Clock className="h-6 w-6" />,
      value: "24/7",
      label: "Customer Support",
    },
    {
      icon: <Award className="h-6 w-6" />,
      value: "98%",
      label: "On-Time Delivery",
    },
  ];

  const advantages = [
    "Punctuality",
    "Standardized scheduling processes",
    "Experienced Scheduling Clerks",
    "Reliable Drivers",
    "Wherever you are, we are never far away",
    "Sub Contractors",
    "Affiliated Companies",
    "Availability as per Demand",
    "Certified Workflows",
    "Employee training (process and touring)",
    "Selected and tested Sub-Contractors",
  ];

  const clients = [
    "Tractors and Farm Equipment Limited",
    "Tafe Motors and Tractors Ltd",
    "Johndeere India Pvt. Ltd",
    "Kubota Agriculture Pvt. Ltd",
    "Sonalika Tractor",
    "Indofarm Equipment Ltd",
    "Same Deutz Fahr India Ltd",
  ];

  return (
    <section id="about" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Company Overview */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">About Us</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We are specialists in transport by land and one of the fastest
            growing companies in road transportation. Our comprehensive network
            spans across every state of India, built on strong pillars of
            massive infrastructure, operational expertise, and a solid financial
            base.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <div className="flex items-center mb-4">
              <Target className="h-8 w-8 text-[#F80D01] mr-3" />
              <h3 className="text-2xl font-bold">Our Mission</h3>
            </div>
            <p className="text-gray-600">
              Our mission is commitment to achieve customer delight through
              improvement in quality services, continuous enhancement of human
              resources, and ceaseless endeavor to provide a base that meets
              corporate objectives. We strive to establish NSIR as trusted
              partners, providing safe and committed services to our esteemed
              customers.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg">
            <div className="flex items-center mb-4">
              <Eye className="h-8 w-8 text-[#F80D01] mr-3" />
              <h3 className="text-2xl font-bold">Our Vision</h3>
            </div>
            <p className="text-gray-600">
              Our vision is to gain market leadership with effective systems and
              excellence in service standards. We aim to reach world-class
              standards in the business, providing transportation services
              precisely tailored to the growing needs of the commerce industry.
              NSIR is the efficient solution for your part and full loads,
              delivering fast, cost-effective, and high-quality solutions.
            </p>
          </div>
        </div>

        {/* Strength */}
        <div className="bg-gray-50 p-8 rounded-lg mb-20">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-4">Our Strength</h3>
            <p className="text-gray-600">
              We have a strong and growing fleet of vehicles equipped with the
              latest technology and maintained through regular services. We
              strive to provide safe and timely transportation of goods to our
              customers.
            </p>
          </div>
        </div>

        {/* Advantages */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold mb-8 text-center">
            Our Advantages
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {advantages.map((advantage, index) => (
              <div
                key={index}
                className="flex items-center p-4 bg-white rounded-lg shadow-md"
              >
                <Shield className="h-5 w-5 text-[#F80D01] mr-3" />
                <span className="text-gray-700">{advantage}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Clients */}
        <div>
          <h3 className="text-2xl font-bold mb-8 text-center">
            Our Prestigious Clients
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {clients.map((client, index) => (
              <div
                key={index}
                className="p-4 bg-white rounded-lg shadow-md text-center"
              >
                <Truck className="h-8 w-8 text-[#F80D01] mx-auto mb-3" />
                <span className="text-gray-700">{client}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#F80D01] text-white mb-3">
                {stat.icon}
              </div>
              <div className="text-2xl font-bold text-gray-900">
                {stat.value}
              </div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
